<template>
  <div class="sidebar" :class="{open}">
    <div class="sidebar-collaps" :class="{open}" @click="toggleSidebar()">
      <svg class="ham hamRotate ham1" :class="{open}" viewBox="0 0 100 100" width="80">
        <path
          class="line top"
          d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
        />
        <path class="line middle" d="m 30,50 h 40" />
        <path
          class="line bottom"
          d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
        />
      </svg>
    </div>
    <div class="sidebar-list">
      <div class="sidebar-list-item" v-for="(item,index) in menu" :key="index">
        <router-link :to="item.href" v-if="item.href">
          <i :class="item.icon"></i>
          <span :class="{open}">{{item.title}}</span>
        </router-link>
        <a
          class="sidebar-list-wrapper"
          :class="{open:item.open}"
          v-else
          @click="toggleChild(item,index)"
        >
          <i :class="item.icon"></i>
          <span :class="{open}">{{item.title}}</span>
          <i class="flaticon-down flaticon--arrow"></i>
        </a>
          <expand-transition v-if="item.child && item.child.length">
            <div class="sidebar-list-child" v-show="item.open">
              <div class="sidebar-list-child-item" v-for="(child,index) in item.child" :key="index">
                <router-link :to="child.href">
                  <i :class="child.icon"></i>
                  <span :class="{open}">{{child.title}}</span>
                </router-link>
              </div>
            </div>
          </expand-transition>
      </div>
    </div>
  </div>
</template>
<script>
import ExpandTransition from "cp/expand.vue";

export default {
  name: "sidebar",
  props: {
    menu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: false
    };
  },
  components: {
    ExpandTransition
  },
  watch:{
    patch(val){
        this.open = false
    }
  },
  methods: {
    toggleSidebar() {
      this.open = !this.open;
    },
    toggleChild(item, index) {
      if (!this.menu[index].open) {
        this.menu.forEach(element => {
          if (element.open) {
            element.open = false;
          }
        });
      }
      this.menu[index].open = !this.menu[index].open;
    }
  }
};
</script>
<style lang="stylus" scoped>
.expand-enter-active, .expand-leave-active
  transition-property opacity, height
.expand-enter, .expand-leave-to
  opacity 0
.sidebar
  position fixed
  top 0
  right 0
  bottom 0
  z-index 3
  overflow hidden
  padding-top 60px
  width 45px
  background #fff
  box-shadow 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)
  text-align center
  font-size 16px
  transition all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06)
  direction ltr
  &.open
    overflow auto
    width 300px
  &-collaps
    position fixed
    top 60px
    right 0
    z-index 66
    display flex
    justify-content center
    align-items center
    margin-bottom 60px
    width 45px
    background-color rgb(191, 203, 217)
    cursor pointer
    transition all 0.2s cubic-bezier(0, -0.22, 0.18, 1.06)
    &.open
      width 300px
    .ham
      width 50px
      height 50px
      border-radius 100%
      cursor pointer
      transition transform 400ms
      user-select none
      -webkit-tap-highlight-color transparent
      -moz-user-select none
      -webkit-user-select none
      -ms-user-select none
    .hamRotate.open
      transform rotate(45deg)
    .hamRotate180.open
      transform rotate(180deg)
    .line
      cursor pointer
      transition stroke-dasharray 400ms, stroke-dashoffset 400ms
      fill none
      stroke #000
      stroke-width 5.5
      stroke-linecap round
    .ham1 .top
      stroke-dasharray 40 139
    .ham1 .bottom
      stroke-dasharray 40 180
    .ham1.open .top
      stroke-dashoffset -98px
    .ham1.open .bottom
      stroke-dashoffset -138px
    .ham1.open .line
      stroke #4caf50
  &-list
    padding-top 60px
    padding-right 7px
    &-item
      position relative
      width 100%
      transition all 0.2s cubic-bezier(0, -0.22, 0.18, 1.06)
      a
        display flex
        flex-direction row-reverse
        justify-content start
        align-items center
        padding 5px 10px
        width 100%
        &:hover, &.router-link-exact-active
          box-shadow inset 0px -3px 0px 0px #4caf50
        span
          overflow hidden
          width 0
          color #000
          text-align right
          white-space nowrap
          font-size 0.9em
          transition width 0.3s ease-out
          &.open
            width 250px
        i
          margin-left 0.8em
          color #000
          font-size 1em
    &-wrapper
      display flex
      cursor pointer
      .flaticon--arrow
        display inline-block
        margin-right auto
        transition all 0.3s ease-in
      &.open
        .flaticon--arrow
          transform scale(1, -1)
    &-child
      padding-right 0
      &.open
        padding-right 15px
      &-item
        a
          display flex
          flex-direction row-reverse
          justify-content start
          align-items center
          padding 5px 10px
          width 100%
          &:hover
            box-shadow inset 0px -3px 0px 0px #4caf50
          span
            overflow hidden
            width 0
            color #000
            text-align right
            white-space nowrap
            font-size 0.9em
            transition width 0.3s ease-out
            &.open
              width 250px
          i
            margin-left 0.8em
            color #000
            font-size 1em
</style>



// WEBPACK FOOTER //
// src/components/dashboard-component/sidebar.vue